import { Paginated } from "../../../../common/domain/models/paginated_models";
import { AcaoPrevCorretivasLista } from "../../domain/models/acao_prev_corretiva_lista";
import { AcaoPrevCorretivasFilter } from "../../domain/models/acao_prev_corretivas_filter copy";
import { AcoesMelhorialListaFilter } from "../../domain/models/acoes_melhorias_filter";
import { AcoePreventivasLista } from "../../domain/models/acoes_melhorias_lista";
import { CronogramaSGQFilter } from "../../domain/models/cronogramasgq_filter";
import { CronogramaSGQLista } from "../../domain/models/cronogramaSGQ_lista";
import { IndicadoresFilter } from "../../domain/models/indicadores_filter";
import { IndicadoresLista } from "../../domain/models/indicadores_lista";
import { ItemProcessosFatorFilter } from "../../domain/models/item_processos_fator_filter";
import { ItemProcessosInteresseFilter } from "../../domain/models/item_processos_interesse_filter";
import { ProcessosIndicadorFilter } from "../../domain/models/processos_indicador_filter";
import { ProcessosRiscosFilter } from "../../domain/models/processos_riscos_filter";
import { ItemProcessoFatorLista } from "../../domain/models/processos_riscos_item_fator_lista";
import { ItemProcessoIndicadorLista } from "../../domain/models/processos_riscos_item_indicador_lista";
import { ItemProcessoRiscosInteresseLista } from "../../domain/models/processos_riscos_item_interesse_lista";
import { ItemProcessoRiscosLista } from "../../domain/models/processos_riscos_item_lista";
import { ProcessoRiscosLista } from "../../domain/models/processos_riscos_lista";
import { ProvisaoRecursoFilter } from "../../domain/models/provisao_recurso_filter";
import { ProvisaoRecursoLista } from "../../domain/models/provisao_recurso_lista";
import { QualidadeIndicadores } from "../../domain/models/qualidade_indicadores";
import { IQualidadeRepository } from "../../domain/repositories/qualidade_repository";
import { CreateAcoePreventivasResponse } from "../daos/create/create_acoes_preventivas";
import { CreateItemProcessoRiscosResponse } from "../daos/create/create_item_processo_riscos";
import { IQualidadeService } from "../services/qualidade_service";

//AuditorRepository

export class QualidadeRepository implements IQualidadeRepository {
  constructor(private readonly service: IQualidadeService) {}

  //#region AcoesMelhoria
  async getAllListagemAcoesMelhorias(
    filter: AcoesMelhorialListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<AcoePreventivasLista>> {
    const response = await this.service.getAllListagemAcoesMelhorias({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): AcoePreventivasLista => ({
          IdAcaoQualidade: item.idAcaoQualidade,
          Tipo: item.tipo,
          AcaoAberta: item.acaoAberta,
          Data: item.data,
          Numero: item.numero,
          DescricaoProblema: item.descricaoProblema,
          AnaliseCausa: item.analiseCausa,
          Abrangencia: item.abrangencia,
          RequisitoNorma: item.requisitoNorma,
          EvidenciaObjetiva: item.evidenciaObjetiva,
          IdCentroCusto: item.idCentroCusto ?? null,
          Arquivo1: item.arquivo1,
          Nomearquivo1: item.nomearquivo1,
          Arquivo2: item.arquivo2,
          Nomearquivo2: item.nomearquivo2,
          RealizarAnalise: item.realizarAnalise,
          Justificativa: item.justificativa,
          Evento: item.evento,
          Assunto: item.assunto,
          DescricaoSetor: item.descricaoSetor ?? "",
          IdentificadoPor: item.identificadoPor,
          nomeArquivo1: item.nomearquivo1,
          nomeArquivo2: item.nomearquivo2,
          DescricaoCentroCusto: item.descricaoCentroCusto,
          Arquivo3: item.arquivo3,
          Arquivo4: item.arquivo4,
          Arquivo5: item.arquivo5,
          nomeArquivo3: item.nomearquivo3,
          nomeArquivo4: item.nomearquivo4,
          nomeArquivo5: item.nomearquivo5,
        }),
      ),
    };
  }

  async createAcoesPreventivas(
    Tipo: number | null,
    AcaoAberta: boolean | null,
    Data: Date | null,
    Numero: number | null,
    DescricaoProblema: string | null,
    AnaliseCausa: string | null,
    Abrangencia: string | null,
    RequisitoNorma: string | null,
    EvidenciaObjetiva: string | null,
    IdCentroCusto: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    RealizarAnalise: boolean | null,
    Justificativa: string | null,
    Evento: string | null,
    Assunto: string | null,
    DescricaoSetor: string | null,
    IdentificadoPor: string | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    nomeArquivo3: string | null,
    nomeArquivo4: string | null,
    nomeArquivo5: string | null,
  ): Promise<CreateAcoePreventivasResponse> {
    const response = await this.service.createAcoesPreventivas({
      Tipo,
      AcaoAberta,
      Data,
      Numero,
      DescricaoProblema,
      AnaliseCausa,
      Abrangencia,
      RequisitoNorma,
      EvidenciaObjetiva,
      IdCentroCusto,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      RealizarAnalise,
      Justificativa,
      Evento,
      Assunto,
      DescricaoSetor,
      IdentificadoPor,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      nomeArquivo4,
      nomeArquivo5,
    });

    return response;
  }

  async updateAcoesPreventivas(
    IdAcaoQualidade: number,
    Tipo: number | null,
    AcaoAberta: boolean | null,
    Data: Date | null,
    Numero: number | null,
    DescricaoProblema: string | null,
    AnaliseCausa: string | null,
    Abrangencia: string | null,
    RequisitoNorma: string | null,
    EvidenciaObjetiva: string | null,
    IdCentroCusto: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    RealizarAnalise: boolean | null,
    Justificativa: string | null,
    Evento: string | null,
    Assunto: string | null,
    DescricaoSetor: string | null,
    IdentificadoPor: string | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    nomeArquivo3: string | null,
    nomeArquivo4: string | null,
    nomeArquivo5: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    limparArquivo3: boolean,
    limparArquivo4: boolean,
    limparArquivo5: boolean,
  ): Promise<void> {
    await this.service.updateAcoesPreventivas({
      IdAcaoQualidade,
      Tipo,
      AcaoAberta,
      Data,
      Numero,
      DescricaoProblema,
      AnaliseCausa,
      Abrangencia,
      RequisitoNorma,
      EvidenciaObjetiva,
      IdCentroCusto,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      RealizarAnalise,
      Justificativa,
      Evento,
      Assunto,
      DescricaoSetor,
      IdentificadoPor,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      nomeArquivo4,
      nomeArquivo5,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3,
      limparArquivo4,
      limparArquivo5,
    });
  }
  async deleteAcoesPreventivas(IdAcaoQualidade: number): Promise<void> {
    await this.service.deleteAcoesPreventivas({ IdAcaoQualidade });
  }

  async getArquivo(
    IdAcaoQualidade: number,
    imagePosition: number,
  ): Promise<Blob> {
    const response = await this.service.getArquivo({
      IdAcaoQualidade,
      imagePosition,
    });
    return response;
  }

  //#endregion

  //#region Acao preventiva corretiva
  async createAcaoPreventivaCorretiva(
    IdAcaoQualidade: number,
    Tipo: "C" | "P" | null,
    Numero: number | null,
    Descricao: string | null,
    IdFuncionarioResponsavel: number | null,
    DataPrevista: Date | null,
    DataRealizado: Date | null,
    AnaliseEvidencia: string | null,
    DataAnalise: Date | null,
    FoiEficaz: boolean | null,
    IdFuncionarioAnalise: number | null,
  ): Promise<void> {
    await this.service.createAcaoPreventivaCorretiva({
      IdAcaoQualidade,
      Tipo,
      Numero,
      Descricao,
      IdFuncionarioResponsavel,
      DataPrevista,
      DataRealizado,
      AnaliseEvidencia,
      DataAnalise,
      FoiEficaz,
      IdFuncionarioAnalise,
    });
  }

  async getAllListagemAcaoPrevCorretivas(
    filter: AcaoPrevCorretivasFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<AcaoPrevCorretivasLista>> {
    const response = await this.service.getAllListagemAcaoPrevCorretivas({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): AcaoPrevCorretivasLista => ({
          IdAcaoQualidade: item.idAcaoQualidade,
          IdAcaoPrevCorretiva: item.idAcaoPrevCorretiva,
          Tipo: item.tipo,
          AnaliseEvidencia: item.analiseEvidencia,
          DataAnalise: item.dataAnalise,
          DataPrevista: item.dataPrevista,
          DataRealizado: item.dataRealizado,
          Descricao: item.descricao,
          FoiEficaz: item.foiEficaz,
          IdFuncionarioAnalise: item.idFuncionarioAnalise,
          IdFuncionarioResponsavel: item.idFuncionarioResponsavel,
          NomeFuncionarioAnalise: item.nomeFuncionarioAnalise,
          NomeFuncionarioResponsavel: item.nomeFuncionarioResponsavel,
          Numero: item.numero,
        }),
      ),
    };
  }

  async updateAcaoPrevCorretivas(
    IdAcaoPrevCorretiva: number,
    IdAcaoQualidade: number,
    Tipo: "C" | "P" | null,
    Numero: number | null,
    Descricao: string | null,
    IdFuncionarioResponsavel: number | null,
    DataPrevista: Date | null,
    DataRealizado: Date | null,
    AnaliseEvidencia: string | null,
    DataAnalise: Date | null,
    FoiEficaz: boolean | null,
    IdFuncionarioAnalise: number | null,
  ): Promise<void> {
    await this.service.updateAcaoPrevCorretivas({
      IdAcaoPrevCorretiva,
      IdAcaoQualidade,
      Tipo,
      Numero,
      Descricao,
      IdFuncionarioResponsavel,
      DataPrevista,
      DataRealizado,
      AnaliseEvidencia,
      DataAnalise,
      FoiEficaz,
      IdFuncionarioAnalise,
    });
  }

  async deleteAcaoPrevCorretivas(
    IdAcaoPrevCorretiva: number,
    IdAcaoQualidade: number,
  ): Promise<void> {
    await this.service.deleteAcaoPrevCorretivas({
      IdAcaoPrevCorretiva,
      IdAcaoQualidade,
    });
  }

  //#endregion

  //#region  CronogramaSGQ
  async getAllListagemCronogramaSGQ(
    filter: CronogramaSGQFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<CronogramaSGQLista>> {
    const response = await this.service.getAllListagemCronogramaSGQ({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): CronogramaSGQLista => ({
          IdCronogramaSGQ: item.idCronogramaSgq,
          IdCentroCusto: item.idCentroCusto,
          Atividade: item.atividade,
          DataPrevista: item.dataPrevista,
          DataPrevistaReal: item.dataPrevistaReal,
          DataRealizada: item.dataRealizada,
          DataRealizadaReal: item.dataRealizadaReal,
          DescResponsavel: item.descResponsavel,
          IdFuncionario: item.idFuncionario,
          Item: item.item,
          NomeResponsavel: item.nomeResponsavel,
          Observacao: item.observacao,
          ResponsavelCadastrado: item.responsavelCadastrado,
          ValorPrevisto: item.valorPrevisto,
          ValorRealizado: item.valorRealizado,
        }),
      ),
    };
  }

  async deleteCronogramaSGQ(IdCronogramaSGQ: number): Promise<void> {
    await this.service.deleteCronogramaSGQ({ IdCronogramaSGQ });
  }
  async createCronogramaSGQ(
    Item?: number | null,
    IdFuncionario?: number | null,
    IdCentroCusto?: number | null,
    Atividade?: string,
    DescResponsavel?: string,
    Observacao?: string,
    ResponsavelCadastrado?: boolean | null,
    DataPrevista?: Date | null,
    DataRealizada?: Date | null,
    DataPrevistaReal?: Date | null,
    DataRealizadaReal?: Date | null,
    ValorPrevisto?: number | null,
    ValorRealizado?: number | null,
  ): Promise<void> {
    await this.service.createCronogramaSGQ({
      Item,
      IdFuncionario,
      IdCentroCusto,
      Atividade,
      DescResponsavel,
      Observacao,
      ResponsavelCadastrado,
      DataPrevista,
      DataRealizada,
      DataPrevistaReal,
      DataRealizadaReal,
      ValorPrevisto,
      ValorRealizado,
    });
  }

  async updateCronogramaSGQ(
    IdCronogramaSGQ: number,
    Item: number | null,
    IdFuncionario: number | null,
    IdCentroCusto: number | null,
    Atividade: string,
    DescResponsavel: string,
    Observacao: string,
    ResponsavelCadastrado: boolean | null,
    DataPrevista: Date | null,
    DataRealizada: Date | null,
    DataPrevistaReal: Date | null,
    DataRealizadaReal: Date | null,
    ValorPrevisto: number | null,
    ValorRealizado: number | null,
  ): Promise<void> {
    await this.service.updateCronogramaSGQ({
      IdCronogramaSGQ,
      Item,
      IdFuncionario,
      IdCentroCusto,
      Atividade,
      DescResponsavel,
      Observacao,
      ResponsavelCadastrado,
      DataPrevista,
      DataRealizada,
      DataPrevistaReal,
      DataRealizadaReal,
      ValorPrevisto,
      ValorRealizado,
    });
  }
  //#endregion

  //#region  ProvisaoRecurso
  async getAllListagemProvisaoRecurso(
    filter: ProvisaoRecursoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ProvisaoRecursoLista>> {
    const response = await this.service.getAllListagemProvisaoRecurso({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): ProvisaoRecursoLista => ({
          IdProvisaoRecurso: item.idProvisaoRecurso,
          DataPrevistaAte: item.dataPrevistaAte,
          DataPrevistaDe: item.dataPrevistaDe,
          DataRealizadaAte: item.dataRealizadaAte,
          DataRealizadaDe: item.dataRealizadaDe,
          Observacao: item.observacao,
          Recurso: item.recurso,
          ValorDesembolsado: item.valorDesembolsado,
          ValorPrevisto: item.valorPrevisto,
        }),
      ),
    };
  }

  async deleteProvisaoRecurso(IdProvisaoRecurso: number): Promise<void> {
    await this.service.deleteProvisaoRecurso({ IdProvisaoRecurso });
  }

  async createProvisaoRecurso(
    Recurso: string,
    Observacao: string | null,
    DataPrevistaDe: Date | null,
    DataPrevistaAte: Date | null,
    DataRealizadaDe: Date | null,
    DataRealizadaAte: Date | null,
    ValorPrevisto: number | null,
    ValorDesembolsado: number | null,
  ): Promise<void> {
    await this.service.createProvisaoRecurso({
      Recurso,
      Observacao,
      DataPrevistaDe,
      DataPrevistaAte,
      DataRealizadaDe,
      DataRealizadaAte,
      ValorPrevisto,
      ValorDesembolsado,
    });
  }
  async updateProvisaoRecurso(
    IdProvisaoRecurso: number,
    Recurso: string,
    Observacao: string | null,
    DataPrevistaDe: Date | null,
    DataPrevistaAte: Date | null,
    DataRealizadaDe: Date | null,
    DataRealizadaAte: Date | null,
    ValorPrevisto: number | null,
    ValorDesembolsado: number | null,
  ): Promise<void> {
    await this.service.updateProvisaoRecurso({
      IdProvisaoRecurso,
      Recurso,
      Observacao,
      DataPrevistaDe,
      DataPrevistaAte,
      DataRealizadaDe,
      DataRealizadaAte,
      ValorPrevisto,
      ValorDesembolsado,
    });
  }

  //#endregion

  //#region Indicadores
  async getAllListagemIndicadores(
    filter: IndicadoresFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<IndicadoresLista>> {
    const response = await this.service.getAllListagemIndicadores({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): IndicadoresLista => ({
          IdIndicador: item.idIndicador,
          Ativo: item.ativo,
          Descricao: item.descricao,
          Item: item.item,
          Frequencia: item.frequencia,
          Indice: item.indice,
          Meta: item.meta,
          Resultado: item.resultado,
        }),
      ),
    };
  }
  async deleteIndicadores(IdIndicador: number): Promise<void> {
    await this.service.deleteIndicadores({ IdIndicador });
  }

  async createIndicadores(
    Item: string | null,
    Descricao: string | null,
    Indice: string | null,
    Frequencia: string | null,
    Meta: string | null,
    Ativo: boolean | null,
    Resultado: string | null,
  ): Promise<void> {
    await this.service.createIndicadores({
      Item,
      Descricao,
      Indice,
      Frequencia,
      Meta,
      Ativo,
      Resultado,
    });
  }

  async updateIndicadores(
    IdIndicador: number,
    Item: string | null,
    Descricao: string | null,
    Indice: string | null,
    Frequencia: string | null,
    Meta: string | null,
    Ativo: boolean | null,
    Resultado: string | null,
  ): Promise<void> {
    await this.service.updateIndicadores({
      IdIndicador,
      Item,
      Descricao,
      Indice,
      Frequencia,
      Meta,
      Ativo,
      Resultado,
    });
  }

  //#endregion

  //#region ProcessosRiscos
  async getAllListagemProcessosRiscos(
    filter: ProcessosRiscosFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ProcessoRiscosLista>> {
    const response = await this.service.getAllListagemProcessosRiscos({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ProcessoRiscosLista => ({
          IdProcesso: item.idProcesso,
          Ano: item.ano,
        }),
      ),
    };
  }
  async deleteProcessoRiscos(IdProcesso: number): Promise<void> {
    await this.service.deleteProcessoRiscos({ IdProcesso });
  }

  async createProcessoRiscos(Ano: string): Promise<void> {
    await this.service.createProcessoRiscos({ Ano });
  }

  async updateProcessoRiscos(IdProcesso: number, Ano: string): Promise<void> {
    await this.service.updateProcessoRiscos({ IdProcesso, Ano });
  }

  async copyProcessoRiscos(IdProcesso: number, Ano: string): Promise<void> {
    await this.service.copyProcessoRiscos({ IdProcesso, Ano });
  }
  //#endregion

  //#region  ItemProcessoRiscos
  async getAllListagemItemProcessoRiscos(
    filter: ItemProcessoRiscosLista,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemProcessoRiscosLista>> {
    const response = await this.service.getAllListagemItemProcessoRiscos({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): ItemProcessoRiscosLista => ({
          IdProcesso: item.idProcesso,
          IdItemProcesso: item.idItemProcesso,
          DataAtualizacao: item.dataAtualizacao,
          Descricao: item.descricao,
          IdFuncionarioResponsavel: item.idFuncionarioResp,
          IdFuncionarioCoresp: item.idFuncionarioCoresp,
          NomeFuncionarioResponsavel: item.nomeFuncionarioResponsavel,
          Observacao: item.observacao,
        }),
      ),
    };
  }

  async deleteItemProcessoRiscos(
    IdItemProcesso: number,
    IdProcesso: number,
  ): Promise<void> {
    await this.service.deleteItemProcessoRiscos({ IdItemProcesso, IdProcesso });
  }

  async createItemProcessoRiscos(
    IdProcesso: number,
    Descricao: string,
    IdFuncionarioResp: number | null,
    IdFuncionarioCoresp: number | null,
    DataAtualizacao: Date | null,
    Observacao: string | null,
  ): Promise<CreateItemProcessoRiscosResponse> {
    const response = await this.service.createItemProcessoRiscos({
      IdProcesso,
      Descricao,
      IdFuncionarioResp,
      IdFuncionarioCoresp,
      DataAtualizacao,
      Observacao,
    });
    return response;
  }
  async updateItemProcessoRiscos(
    IdItemProcesso: number,
    IdProcesso: number,
    Descricao: string,
    IdFuncionarioResp: number | null,
    IdFuncionarioCoresp: number | null,
    DataAtualizacao: Date | null,
    Observacao: string | null,
  ): Promise<void> {
    await this.service.updateItemProcessoRiscos({
      IdItemProcesso,
      IdProcesso,
      Descricao,
      IdFuncionarioResp,
      IdFuncionarioCoresp,
      DataAtualizacao,
      Observacao,
    });
  }

  //#endregion

  //#region Processo Interesse
  async getAllListagemItemProcessoInteresse(
    filter: ItemProcessosInteresseFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemProcessoRiscosInteresseLista>> {
    const response = await this.service.getAllListagemItemProcessoInteresse({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): ItemProcessoRiscosInteresseLista => ({
          Acompanhamento: item.acompanhamento,
          IdItemProcesso: item.idItemProcesso,
          Expectativa: item.expectativa,
          Descricao: item.descricao,
          IdItemProcessoInteresse: item.idItemProcessoInteresse,
          ResultadosAlcancados: item.resultadosAlcancados,
        }),
      ),
    };
  }
  async createItemProcessoRiscosInteresse(
    IdItemProcesso: number,
    Descricao: string | null,
    Expectativa: string | null,
    Acompanhamento: string | null,
    ResultadosAlcancados: string | null,
  ): Promise<void> {
    await this.service.createItemProcessoRiscosInteresse({
      IdItemProcesso,
      Descricao,
      Expectativa,
      Acompanhamento,
      ResultadosAlcancados,
    });
  }
  async updateItemProcessoRiscosInteresse(
    IdItemProcessoInteresse: number,
    IdItemProcesso: number,
    Descricao: string | null,
    Expectativa: string | null,
    Acompanhamento: string | null,
    ResultadosAlcancados: string | null,
  ): Promise<void> {
    await this.service.updateItemProcessoRiscosInteresse({
      IdItemProcessoInteresse,
      IdItemProcesso,
      Descricao,
      Expectativa,
      Acompanhamento,
      ResultadosAlcancados,
    });
  }
  async deleteItemProcessoInteresse(
    IdItemProcessoInteresse: number,
    IdItemProcesso: number,
  ): Promise<void> {
    await this.service.deleteItemProcessoInteresse({
      IdItemProcessoInteresse,
      IdItemProcesso,
    });
  }
  //#endregion

  //#region  ItemProcessoFator
  async getAllListagemItemProcessoFator(
    filter: ItemProcessosFatorFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemProcessoFatorLista>> {
    const response = await this.service.getAllListagemItemProcessoFator({
      ...filter,
      currentPage,
      rowsPerPage,
    });

    return {
      ...response,
      items: response.items.map(
        (item): ItemProcessoFatorLista => ({
          IdItemProcessoFator: item.idItemProcessoFator,
          IdItemProcesso: item.idItemProcesso,
          Acao: item.acao,
          Acompanhamento: item.acompanhamento,
          Consequencia: item.consequencia,
          FatorRisco: item.fatorRisco,
          Impacto: item.impacto,
          IternoExterno: item.iternoExterno,
          Ocorrencia: item.ocorrencia,
          Oportunidade: item.oportunidade,
          RiscoOportunidade: item.riscoOportunidade,
        }),
      ),
    };
  }
  async createItemProcessoFator(
    IdItemProcesso: number | null,
    FatorRisco: string | null,
    IternoExterno: string | null,
    Consequencia: string | null,
    Oportunidade: string | null,
    Acao: string | null,
    Acompanhamento: string | null,
    Ocorrencia: number | null,
    Impacto: number | null,
    RiscoOportunidade: number | null,
  ): Promise<void> {
    await this.service.createItemProcessoFator({
      IdItemProcesso,
      FatorRisco,
      IternoExterno,
      Consequencia,
      Oportunidade,
      Acao,
      Acompanhamento,
      Ocorrencia,
      Impacto,
      RiscoOportunidade,
    });
  }
  async updateItemProcessoFator(
    IdItemProcessoFator: number,
    IdItemProcesso: number | null,
    FatorRisco: string | null,
    IternoExterno: string | null,
    Consequencia: string | null,
    Oportunidade: string | null,
    Acao: string | null,
    Acompanhamento: string | null,
    Ocorrencia: number | null,
    Impacto: number | null,
    RiscoOportunidade: number | null,
  ): Promise<void> {
    await this.service.updateItemProcessoFator({
      IdItemProcessoFator,
      IdItemProcesso,
      FatorRisco,
      IternoExterno,
      Consequencia,
      Oportunidade,
      Acao,
      Acompanhamento,
      Ocorrencia,
      Impacto,
      RiscoOportunidade,
    });
  }
  async deleteItemProcessoFator(
    IdItemProcessoFator: number,
    IdItemProcesso: number,
  ): Promise<void> {
    await this.service.deleteItemProcessoFator({
      IdItemProcessoFator,
      IdItemProcesso,
    });
  }
  //#endregion

  //#region ItemProcessoIndicadores
  async createProcesoIndicadores(
    IdItemProcessoIndicador: number,
    IdItemProcesso: number,
    IdIndicador: number[],
  ): Promise<void> {
    await this.service.createProcesoIndicadores({
      IdItemProcessoIndicador,
      IdItemProcesso,
      IdIndicador,
    });
  }
  async getAllListagemItemProcessoIndicador(
    filter: ProcessosIndicadorFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemProcessoIndicadorLista>> {
    const response = await this.service.getAllListagemItemProcessoIndicador({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ItemProcessoIndicadorLista => ({
          Descricao: item.indicador,
          IdItemProcesso: item.idItemProcesso,
          Frequencia: item.frequencia,
          Indice: item.indice,
          Item: item.item,
          Meta: item.meta,
          IdItemProcessoIndicador: item.idItemProcessoIndicador,
        }),
      ),
    };
  }
  async deleteItemProcessoIndicador(
    IdItemProcessoIndicador: number,
    IdItemProcesso: number,
  ): Promise<void> {
    await this.service.deleteItemProcessoIndicador({
      IdItemProcessoIndicador,
      IdItemProcesso,
    });
  }
  //#endregion
  //#region Principal
  async getAllIndicadores(): Promise<QualidadeIndicadores> {
    const response = await this.service.getAllIndicadores();
    return response.indicadores;
  }
  //#endregion
}
